import {SET_LOADING} from "./availableActions";
import {SetLoadingAction} from "../../interfaces/store/actions/mask";

export const setLoading = (payload: boolean): SetLoadingAction => ({
    type: SET_LOADING,
    payload,
});
